(() => {
  'use strict';
  const key = 'yg-inquiry-origin-v1';
  const pendingKey = 'yg-pending-inquiry-v1';
  const ttl = 30 * 60 * 1000;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const clear = key => { try { sessionStorage.removeItem(key); } catch {} };
  const params = new URLSearchParams(location.search);
  const fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const clean = value => String(value || '').replace(/[\u0000-\u001f\u007f<>]/g, '').slice(0, 160);
  let origin = read(key);
  if (!origin || Date.now() - origin.time > ttl) origin = null;
  if (fields.some(field => params.has(field))) {
    origin = {time: Date.now(), path: location.pathname, campaign: Object.fromEntries(fields.map(field => [field, clean(params.get(field))]))};
    write(key, origin);
  }
  const forms = document.querySelectorAll('form#yg-business-form, form#wholesale-native-request');
  forms.forEach(form => {
    if (origin) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'contact[Campaign attribution]';
      input.value = JSON.stringify({landing: origin.path, ...origin.campaign});
      form.append(input);
    }
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      const id = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      write(pendingKey, {id, path: location.pathname, time: Date.now(), form: form.id});
    });
  });
  const pending = read(pendingKey);
  const success = document.querySelector('[data-yg-lead-success="true"]');
  if (pending && Date.now() - pending.time < ttl && pending.path === location.pathname && success) {
    clear(pendingKey);
    const detail = {event_id: pending.id, form: pending.form, path: pending.path};
    window.YGConfirmedInquiry = Object.freeze(detail);
    window.dispatchEvent(new CustomEvent('yg:inquiry-confirmed', {detail}));
    const kinds = {'/pages/buyer-application': 'wholesale_application', '/pages/sample-orders': 'sample_request', '/pages/private-label': 'private_label', '/pages/contact': 'contact', '/pages/ring-catalogue': 'invoice_request'};
    let attempts = 0;
    const publish = () => {
      const api = window.Shopify?.analytics;
      if (!api?.publish) {
        if (++attempts < 40) setTimeout(publish, 500);
        return;
      }
      try {
        const result = api.publish('yegieonr:inquiry_confirmed', {...detail, inquiry_type: kinds[pending.path] || 'inquiry'});
        if (result && typeof result.catch === 'function') result.catch(() => {});
      } catch {}
    };
    publish();
  } else if (document.querySelector('form .errors') || (pending && Date.now() - pending.time >= ttl)) clear(pendingKey);
})();
